
import {serializable, alias, object, list, primitive} from 'serializr';

export class MetaData { 

	@serializable(alias('name', primitive()))
	name?: string;

	@serializable(alias('name', primitive()))
	value?: string;

}